import React, { useState } from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import FluidImage from 'src/utils/FluidImage'
import Heading from 'src/components/Heading'
import Button from 'src/components/Button'
import Label from 'src/components/Label'
import Slider from "react-slick";
import resolveLink from 'src/utils/resolveLink'
import { Link } from 'gatsby'

const PrevArrow = props => {
    const { onClick } = props
    return (
        <div
            className={'group h-11 w-11 bg-white hover:bg-blue duration-300 lg:flex hidden items-center justify-center rounded-full absolute left-20 top-[calc(50%-80px)] z-10'}
            onClick={onClick}
            onKeyDown={onClick}
            role="button"
            tabIndex={0}
        >
            <i className="fa-solid fa-chevron-left group-hover:text-white duration-300"></i>
        </div>
    );
};

const NextArrow = props => {
    const { onClick } = props
    return (
        <div
            className={'group h-11 w-11 bg-white hover:bg-blue duration-300 lg:flex hidden items-center justify-center rounded-full absolute right-20 top-[calc(50%-80px)] z-10'}
            onClick={onClick}
            onKeyDown={onClick}
            role="button"
            tabIndex={0}
        >
            <i className="fa-solid fa-chevron-right group-hover:text-white duration-300"></i>
        </div>
    );
};

const CarouselWithIntro = ({ blok }) => {

    const [currentIndex, setCurrentIndex] = useState(0);

    const settings = {
        className: "center scale mt-14",
        centerMode: true,
        infinite: true,
        centerPadding: "25%",
        slidesToShow: 1,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        swipeToSlide: true,
        focusOnSelect: true,
        arrows: true,
        adaptiveHeight: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        dotsClass: `slick-dots !-bottom-16`,
        beforeChange: (current, next) => setCurrentIndex(next),
        appendDots: dots => (
            <div>
            <ul className="">
                {dots.map((item, index) => (
                    <li className="!m-1 !h-[12px] !w-[12px]" key={index}>
                    {item.props.children}
                    </li>
                ))}
            </ul>
        </div>
          ),
        customPaging: i => (
            <div
                className={`relative w-full h-full transition-colors rounded-full duration-300 ${
                i === currentIndex ? "bg-blue" : "bg-darkblue-200"
                }`}
            ></div>
        ),
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    centerPadding: "20%",
                }
            },
            {
                breakpoint: 769,
                settings: {
                    centerPadding: "10%",
                }
            },
        ]
    };

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div>
                <div className="bg-white lg:pt-24 pt-12 lg:pb-32 pb-20">
                    <div className="relative max-w-7xl mx-auto px-6">
                        <div className="flex lg:flex-row flex-col lg:justify-between lg:items-end gap-y-4">
                            <div>
                                <Label className="text-teal mb-5">{blok.label}</Label>
                                <Heading size="h3">{blok.title}</Heading>
                                <div className="prose lg:text-base text-sm max-w-3xl">
                                    <RichText>{blok.description}</RichText>
                                </div>
                            </div>
                            {blok.button_text &&
                                <div>
                                    <Button to={blok.button_target.cached_url} className="bg-red hover:bg-darkred">{blok.button_text}</Button>
                                </div>
                            }
                        </div>
                    </div>
                    <Slider {...settings}>
                        {blok.slides?.map((slide, index) => (
                            <div className={`p-1 rounded-lg`} key={slide._uid}>
                                {blok.images_links ?
                                    <Link to={resolveLink(slide.button_target?.cached_url)}>
                                        <FluidImage image={slide.image} className="rounded-lg"/>
                                    </Link>
                                    :
                                    <FluidImage image={slide.image} className="rounded-lg"/>
                                }
                                <div className={`max-w-lg mx-auto text-center mt-8 duration-300 ${index !== currentIndex && 'opacity-0'}`}>
                                    {!blok.disable_titles &&
                                        <Heading size="h4">{slide.title}</Heading>
                                    }
                                    <p className={`text-darkblue-600 lg:text-base text-sm`}>{slide.description}</p>
                                    {(slide.button_text && !blok.images_links) && 
                                        <Button to={slide.button_target?.cached_url} target={slide.button_target?.linktype !== 'story' && '_blank'} className="bg-teal hover:bg-darkteal mt-6">{slide.button_text}</Button>
                                    }
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </SbEditable>
    )
}

export default CarouselWithIntro